<template>
  <span>
    <v-text-field
      ref="cajaTexto"
      class="mr-3 mb-0 mt-0"
      readonly
      dense
      hide-details
      clearable
      append-icon="mdi-calendar"
      :value="descripcionRangoFechas"
      v-bind="$attrs"
      @click="mostrarMenu"
      @click:append="mostrarMenu"
      @click:clear="clickClear"
    />

    <v-menu
      v-model="menuVisible"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      :close-on-content-click="false"
    >
      <v-card width="400px">
        <v-card-title v-if="tituloVisible && tituloDialogo != ''">
          {{ tituloDialogo }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <div class="caption mb-2">
                Rangos predefinidos:
              </div>
              <!-- <v-chip
                v-for="(rango, i) in arrayRangosPredefinidos"
                :key="i"
                :class="['ma-1', claseCSSChipRangoPredefinido (rango)]"
                small
                :ripple="false"
                @click="clickRangoFechasHorasPredeterminado (rango)"
              >
                {{ rango.texto }}
              </v-chip> -->

              <span v-for="(rango, i) in arrayRangosPredefinidos" :key="i">
                <v-chip
                  v-if="rango.visible"
                  :class="['ma-1', claseCSSChipRangoPredefinido (rango)]"
                  small
                  :ripple="false"
                  @click="clickRangoFechasHorasPredeterminado (rango)"
                >{{ rango.texto }}</v-chip>
              </span>

              <SelectorFechaHora
                class="mt-8"
                tituloFecha="Fecha/hora Desde"
                formato-modelo="ISO"
                :literal-null="$t ('---')"
                hora-por-defecto="00:00"
                :ajustar-segundos="0"
                :ajustar-milisegundos="0"
                v-model="fechaHoraDesdeInterno"
                boton-borrar
                @change="seleccionarTipoRangoPersonalizado"
              />

              <SelectorFechaHora
                tituloFecha="Fecha/hora Hasta"
                formato-modelo="ISO"
                :literal-null="$t ('---')"
                hora-por-defecto="23:59"
                :ajustar-segundos="59"
                :ajustar-milisegundos="998"
                v-model="fechaHoraHastaInterno"
                boton-borrar
                @change="seleccionarTipoRangoPersonalizado"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="clickBorrar">Borrar</v-btn>
          <v-spacer />
          <v-btn text color="green" @click="clickAceptar">Aceptar</v-btn>
          <v-btn text @click="clickCancelar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </span>
</template>

<script>
import SelectorFechaHora from '@/components/SelectorFechaHora.vue'
import { DateTime } from "luxon";

export default {
  components: { SelectorFechaHora },
  props: {
    value: {
      required: true,
    },
    tituloDialogo: {
      type: String,
      default: "",
    },
    tituloVisible: {
      type: Boolean,
      default: true,
    },
    formatoModelo: {
      type: String,
      default: "sql",
    },
    permitirRangoSinFechaHora: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      menuVisible: false,
      x: 0,
      y: 0,
      arrayRangosPredefinidos: [],
      tipoRangoSeleccionado: null,
      fechaHoraDesdeInterno: null,
      fechaHoraHastaInterno: null,
    }
  },
  computed: {
    descripcionRangoFechas() {
      if (this.value && Array.isArray (this.value.value))
        return this.value.text;
      else
        return "";
    }
  },
  methods: {
    claseCSSChipRangoPredefinido (rango) {
      if (rango == this.tipoRangoSeleccionado)
        return "primary";
      else
        return "";
    },
    literalFechaHora (fechaHora) {
      if (fechaHora)
        return DateTime.fromISO (fechaHora).setLocale("es").toFormat("D T");
      else
        return "...";
    },
    formatoModelo2ISODate (fechaHora) {
      if (fechaHora) {
        if (this.formatoModelo.toUpperCase() == "SQL")
          return DateTime.fromSQL (fechaHora).toISO();
        else
          return fechaHora;
      } else
        return null;
    },
    ISODate2formatoModelo (fechaHora) {
      if (fechaHora) {
        if (this.formatoModelo.toUpperCase() == "SQL")
          return DateTime.fromISO (fechaHora).toFormat("yyyy-MM-dd HH:mm:ss");
        else
          return fechaHora;
      } else
        return null;
    },
    mostrarMenu () {
      this.menuVisible = false;

      this.x = this.$refs['cajaTexto'].$el.getBoundingClientRect().x;
      this.y = this.$refs['cajaTexto'].$el.getBoundingClientRect().y + 27;

      this.arrayRangosPredefinidos = [
        { visible: true, texto: "Última hora",      desde: DateTime.now().minus({hours: 1}),                   hasta: DateTime.now() },
        { visible: true, texto: "Últimas 24 horas", desde: DateTime.now().minus({days: 1}),                    hasta: DateTime.now() },
        { visible: true, texto: "Hoy",              desde: DateTime.now().startOf('day'),                      hasta: DateTime.now().endOf('day') },
        { visible: true, texto: "Ayer",             desde: DateTime.now().minus({days: 1}).startOf('day'),     hasta: DateTime.now().minus({days: 1}).endOf('day') },
        { visible: true, texto: "Últimos 7 días",   desde: DateTime.now().minus({days: 7}).startOf('day'),     hasta: DateTime.now().minus({days: 1}).endOf('day') },
        { visible: true, texto: "Últimos 15 días",  desde: DateTime.now().minus({days: 15}).startOf('day'),    hasta: DateTime.now().minus({days: 1}).endOf('day') },
        { visible: true, texto: "Últimos 30 días",  desde: DateTime.now().minus({days: 30}).startOf('day'),    hasta: DateTime.now().minus({days: 1}).endOf('day') },
        { visible: true, texto: "Este mes",         desde: DateTime.now().startOf('month'),                    hasta: DateTime.now().endOf('month') },
        { visible: true, texto: "El mes pasado",    desde: DateTime.now().minus({months: 1}).startOf('month'), hasta: DateTime.now().minus({months: 1}).endOf('month') },
        { visible: true, texto: "Últimos 3 meses",  desde: DateTime.now().minus({months: 3}).startOf('month'), hasta: DateTime.now().minus({months: 1}).endOf('month') },
        { visible: true, texto: "Últimos 6 meses",  desde: DateTime.now().minus({months: 6}).startOf('month'), hasta: DateTime.now().minus({months: 1}).endOf('month') },
        { visible: true, texto: "Este año",         desde: DateTime.now().startOf('year'),                     hasta: DateTime.now().endOf('year') },
        { visible: true, texto: "El año pasado",    desde: DateTime.now().minus({year: 1}).startOf('year'),    hasta: DateTime.now().minus({year: 1}).endOf('year') },
        { visible: true, texto: "Personalizado",    desde: null,                                               hasta: null },
        { visible: this.permitirRangoSinFechaHora, texto: "Sin fecha/hora",   desde: null,                                               hasta: null },
      ];

      // al abrir, debemos cargar los datos de "value" en el formulario
      if (this.value && Array.isArray (this.value.value)) {
        this.fechaHoraDesdeInterno = this.formatoModelo2ISODate (this.value.value[0]);
        this.fechaHoraHastaInterno = this.formatoModelo2ISODate (this.value.value[1]);
        this.tipoRangoSeleccionado = this.arrayRangosPredefinidos.find ((e) => e.texto == this.value.text);
        if (!this.tipoRangoSeleccionado)
          this.seleccionarTipoRangoPersonalizado();
      } else
        this.tipoRangoSeleccionado = null;

      this.$nextTick(() => {
        this.menuVisible = true;
      })
    },
    clickRangoFechasHorasPredeterminado (rango) {
      this.tipoRangoSeleccionado = rango;
      this.fechaHoraDesdeInterno = rango.desde ? rango.desde.toISO() : null;
      this.fechaHoraHastaInterno = rango.hasta ? rango.hasta.toISO() : null;

      if (rango != this.arrayRangosPredefinidos [this.arrayRangosPredefinidos.length-2])
        this.clickAceptar();
    },
    clickBorrar () {
      this.fechaHoraDesdeInterno = null;
      this.fechaHoraHastaInterno = null;
      this.tipoRangoSeleccionado = null;
    },
    clickAceptar () {
      this.menuVisible = false;

      let aux = null;

      if (this.tipoRangoSeleccionado && !this.permitirRangoSinFechaHora && !this.fechaHoraDesdeInterno && !this.fechaHoraHastaInterno)
        this.tipoRangoSeleccionado = null;

      if (this.tipoRangoSeleccionado)  {
        aux = {};
        aux.value = [this.ISODate2formatoModelo (this.fechaHoraDesdeInterno), this.ISODate2formatoModelo (this.fechaHoraHastaInterno)];
        if (!this.fechaHoraDesdeInterno && !this.fechaHoraHastaInterno)  // si no se especifica ninguna fecha/hora, establecemos el tipo de rango "Sin fecha/hora"
          this.tipoRangoSeleccionado = this.arrayRangosPredefinidos [this.arrayRangosPredefinidos.length-1];

        if (this.tipoRangoSeleccionado == this.arrayRangosPredefinidos [this.arrayRangosPredefinidos.length-2])
          aux.text = this.literalFechaHora (this.formatoModelo2ISODate (this.fechaHoraDesdeInterno)) + " ~ " + this.literalFechaHora (this.formatoModelo2ISODate (this.fechaHoraHastaInterno))
        else
          aux.text = this.tipoRangoSeleccionado.texto;
      }

      this.$emit ('input', aux);

      this.$nextTick (() => {
        this.$emit ('change', aux);
      });
    },
    clickCancelar () {
      this.menuVisible = false;
    },
    clickClear () { // icono del v-field-text para borrar la entrada de datos
      this.clickBorrar();
      this.clickAceptar();
    },
    seleccionarTipoRangoPersonalizado () {
      this.tipoRangoSeleccionado = this.arrayRangosPredefinidos [this.arrayRangosPredefinidos.length-2];
    }
  }
}
</script>

<style>

</style>